//import Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//import Components
import Navigation from '../../components/Navigation/Navigation';

import Footer from '../../components/Footer/Footer';

//import Styles
import './Layout.css';

class Layout extends Component{
    constructor(props){
        super(props);
    }

    componentDidMount() {
        // Decode entities in the URL
        // Sometimes a URL like #/foo#bar will be encoded as #/foo%23bar
        window.location.hash = window.decodeURIComponent(window.location.hash);
        const scrollToAnchor = () => {
            const hashParts = window.location.hash.split('#');
            if (hashParts.length > 2) {
            const hash = hashParts.slice(-1)[0];
            document.querySelector(`#${hash}`).scrollIntoView();
            }
        };
        scrollToAnchor();
        window.onhashchange = scrollToAnchor;
    }

    render(){
        return(
            <React.Fragment>
                <div style={{minHeight: window.innerHeight}}>
                    {<Navigation relative={this.props.relative} isStore={this.props.isStore}/>}
                        {this.props.children}
                </div>
                {/* <div className="ScrollTop" onClick={()=>{window.scrollTo(0,0);}}><p><strong>{"↑\n위로가기"}</strong></p></div> */}
                <div className="ScrollTop" onClick={()=>{window.scrollTo(0,0);}}>
                    <p><span>{"⤒"}</span>{"\n위로가기"}</p>
                </div>
                <Footer lang={this.props.universal.language}/>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return { 
        universal: state.universal 
    };
}


export default connect(mapStateToProps, null)(Layout);

Layout.propTypes = {
    isStore : PropTypes.bool
}

Layout.defaultProps = {
    isStore : false
}


// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js